import * as types from './types';

export default {
  state: {
    studentList: [],
    currentDate: null,
  },
  getters: {
    [types.STUDENT_LIST]: state => state.studentList,
    [types.CURRENT_DATE]: state => state.currentDate,
  },
  mutations: {
    [types.STUDENT_LIST]: (state, payload) => {
      state.studentList = payload.studentList;
    },
    [types.CURRENT_DATE]: (state, payload) => {
      state.currentDate = payload.currentDate;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/student/create/index.js